import type { ReactNode } from 'react';
import { BotaoTema } from './BotaoTema';
import { Logo } from './Logo';
import { MapaDeFundo } from './MapaDeFundo';
import css from './TelaDeEntrada.module.css';

/**
 * Moldura das telas de entrada (entrar, criar loja, nova senha), no idioma das telas de entrada dos
 * apps: o mapa animado (metade da tela no computador, topo no celular) e o formulário ao lado.
 */
export function TelaDeEntrada({
  titulo,
  subtitulo,
  children,
}: {
  titulo: string;
  subtitulo?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className={css.tela}>
      <div className={css.mapa}>
        <MapaDeFundo />
        <div className={css.topo}>
          <Logo altura={41} />
          <BotaoTema />
        </div>
        <div className={css.vidro} aria-hidden="true">
          <span className={css.vidroRotulo}>Ao vivo</span>
          <span className={css.vidroTexto}>O cliente vê a entrega chegando</span>
        </div>
      </div>
      <main className={css.lado}>
        <div className={css.conteudo}>
          <div className={css.cabecalho}>
            <h1 className={css.titulo}>{titulo}</h1>
            {subtitulo ? <p className={css.subtitulo}>{subtitulo}</p> : null}
          </div>
          {children}
        </div>
      </main>
    </div>
  );
}
